import { render, staticRenderFns } from "./TabOperational.vue?vue&type=template&id=517068be"
import script from "./TabOperational.vue?vue&type=script&lang=js"
export * from "./TabOperational.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports